/*!

=========================================================
* - v1.4.0
=========================================================

* Product Page: 
* Copyright 2020 Ahmed Abosaif


* Coded by Ahmed Abosaif

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import {  HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";



import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/now-ui-dashboard.scss?v1.4.0";
//import "assets/css/demo.css";
import Loginpg from "components/login/login.component.js"
//import AdminDash from "views/Dashboard.js"
//import UserHome from "views/enduser-home.js"

import AdminLayout from "layouts/Admin.js";
import EnduserLayout from "layouts/Enduser.js";

import AuthService from "services/auth.service";
import Outsidetkt from "views/outsideTktbyid";
import Alltickets from "views/AllTickets";


const hist = createBrowserHistory();
const currentUser =  AuthService.getCurrentUser();
let superout= '';
let redir= '';
//01009518284 here changed Adminlayput to be Enduser Layout
if (currentUser) {
  if (currentUser.roles.includes('ROLE_AGENT')) {superout = <Route path="/admin" render={(props) => <AdminLayout {...props} />} />; 
  redir = <Redirect to="/admin/dashboard" />;}
  
  else {superout = <Route path="/user" render={(props) => <EnduserLayout {...props} />} />; 
  redir = <Redirect to="/user/home" />;}
  
  

console.log(currentUser.roles)

}
else {superout = <Route path="/*" component={Loginpg} />}


ReactDOM.render(
  <Router history={hist}>
    <Switch>
    <Route exact path={"/login"} component={Loginpg} />


{superout} 

<Route exact path={"/gettkt/:tktid"} component={Outsidetkt} />


{redir}

</Switch>
  </Router>,
  document.getElementById("root")
);
